import { useQuery } from '@tanstack/react-query';

import { DreGrupo, DreSubgrupo } from '../../types';

import { useRequestListagem } from 'hooks/useRequestListagem';

export function useQuerySubgrupos({ grupo }: { grupo: DreGrupo | null }) {
    const requestListagem = useRequestListagem();
    const { dreMercadologicaTipoGrupoExibicaoEnum, idDreMercadologicaTipoGrupoExibicao } = grupo || {};

    return useQuery<DreSubgrupo[]>(
        ['querySubgrupos', idDreMercadologicaTipoGrupoExibicao],
        () =>
            requestListagem({
                url: `/dre/dremercadologicagrupoexibicao/tipogrupoexibicao/${idDreMercadologicaTipoGrupoExibicao}`,
            }).then((res) => res.data.data),
        {
            enabled: Boolean(dreMercadologicaTipoGrupoExibicaoEnum && dreMercadologicaTipoGrupoExibicaoEnum !== 'IMPOSTOS'),
        },
    );
}
